export class Email {
    public addressList: string[];
    public subject: string;
    public message: string;
}